// src/props/solid.js
var solid = (obj, name, value, enumerable = true, configurable = false) => {
  return Object.defineProperty(obj, name, { enumerable, value, configurable });
};
var solids = (obj, namedValues, enumerable = true, configurable = false) => {
  for (const name in namedValues) {
    const value = namedValues[name];
    solid(obj, name, value, enumerable, configurable);
  }
  return obj;
};

// src/props/virtual.js
var virtual = (obj, name, get, enumerable = true, configurable = false) => {
  return Object.defineProperty(obj, name, { enumerable, get, configurable });
};
var virtuals = (obj, namedGets, enumerable = true, configurable = false) => {
  for (const name in namedGets) {
    const get = namedGets[name];
    virtual(obj, name, get, enumerable, configurable);
  }
  return obj;
};

// src/props/safe.js
var safe = (obj, priv, name, set, get, enumerable = true, configurable = false) => {
  return Object.defineProperty(obj, name, {
    set: set ? (v) => priv[name] = set(v, priv[name], name) : void 0,
    get: get ? (_) => get(priv[name], name) : (_) => priv[name],
    enumerable,
    configurable
  });
};
var safes = (obj, priv, namedSetsAndGets, enumerable = true, configurable = false) => {
  for (const name in namedSetsAndGets) {
    const setGet = namedSetsAndGets[name];
    let set, get;
    if (typeof setGet !== "object") {
      set = setGet;
    } else {
      set = setGet.set || setGet[0];
      get = setGet.get || setGet[1];
    }
    safe(obj, priv, name, set, get, enumerable, configurable);
  }
  return obj;
};

// src/props/cached.js
var cached = (obj, priv, name, reset, get, enumerable = true, configurable = false) => {
  const setAndGet = (v) => {
    if (!priv.hasOwnProperty(name)) {
      v = priv[name] = reset(name);
    }
    return get ? get(v, name) : v;
  };
  return safe(obj, priv, name, null, setAndGet, enumerable, configurable);
};
var cacheds = (obj, priv, namedResetsAndGets, enumerable = true) => {
  for (const name in namedResetsAndGets) {
    const resetGet = namedResetsAndGets[name];
    let reset, get;
    if (typeof resetGet !== "object") {
      reset = resetGet;
    } else {
      reset = resetGet.reset || resetGet[0];
      get = resetGet.get || resetGet[1];
    }
    cached(obj, priv, name, reset, get, enumerable);
  }
  return obj;
};
export {
  cached,
  cacheds,
  safe,
  safes,
  solid,
  solids,
  virtual,
  virtuals
};
//# sourceMappingURL=index.js.map
